import { RSA } from '../../../components/Security/SignatureSettings/types';
import { loginApi } from '../../setup/setupApi';
import { HMACSecret, RSASecrets } from './types';

export const getHMACSecret = (projectId: string): Promise<HMACSecret> =>
  loginApi.get(`projects/${projectId}/secret`).then((res) => res.data);

export const putHMACSecret = (projectId: string, secret: string): Promise<HMACSecret> =>
  loginApi.put(`projects/${projectId}/secret`, { secret }).then((res) => res.data);

export const getRSASecret = (projectId: string): Promise<RSASecrets> =>
  loginApi.get(`projects/${projectId}/keys`).then((res) => res.data);

export const generateRSASecret = (projectId: string): Promise<RSA> =>
  loginApi.post(`projects/${projectId}/reset_key`).then((res) => res.data);

export const enableRSASecret = (projectId: string, kid: string): Promise<Partial<RSA>> =>
  loginApi.put(`projects/${projectId}/reset_key`, { kid }).then((res) => res.data);

export const disableRSASecret = (projectId: string): Promise<RSASecrets> =>
  loginApi.delete(`projects/${projectId}/keys`).then((res) => res.data);
